import { CommonModule } from '@angular/common';
import { Component, inject, signal, ViewContainerRef } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzDropdownModule } from 'ng-zorro-antd/dropdown';
import { NzFlexModule } from 'ng-zorro-antd/flex';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzInputModule } from 'ng-zorro-antd/input';
import { NzModalModule, NzModalService } from 'ng-zorro-antd/modal';
import { NzTableModule } from 'ng-zorro-antd/table';
import { NzTagModule } from 'ng-zorro-antd/tag';
import { SettlementProfile } from '../../../../core/api/mhsIdentityApiClient';
import { NfzService } from '../../services/nfz-service';
import { SettlementsPasswordChange } from '../settlements-password-change/settlements-password-change';

@Component({
  selector: 'app-settlements-view',
  imports: [
    CommonModule,
    NzTableModule,
    NzFlexModule,
    NzIconModule,
    CommonModule,
    FormsModule,
    NzTableModule,
    NzInputModule,
    NzButtonModule,
    NzIconModule,
    NzFlexModule,
    NzDropdownModule,
    NzTagModule,
    NzModalModule,
  ],
  templateUrl: './settlements-view.html',
  styleUrl: './settlements-view.scss',
})
export class SettlementsViewComponent {
  readonly nfzService = inject(NfzService);
  readonly loading = signal(true);
  readonly profiles = signal<SettlementProfile[]>([]);
  readonly viewContainerRef = inject(ViewContainerRef);
  readonly messageService = inject(NzModalService);
  constructor() {
    this.loadProfiles();
  }

  private loadProfiles(): void {
    this.loading.set(true);
    this.nfzService.searchSettlementsProfiles().subscribe({
      next: (result) => {
        this.profiles.set(result ?? []);
        this.loading.set(false);
      },
      error: (error) => {
        console.error('Unable to load settlements profiles.', error);
        this.loading.set(false);
      },
    });
  }
  toLoginTypeLabel(roleType: string): string {
    return roleType === 'SWD' ? 'Świadczeniodawca' : 'Lekarz';
  }
  changePasswordClick(serviceProviderCode: string): void {
    this.changePasswordClickModal(serviceProviderCode);
  }
  changePasswordClickModal(serviceProviderCode: string): void {
    const modal = this.messageService.create<SettlementsPasswordChange, string>({
      nzTitle: 'Zmień hasło użytkownika',
      nzContent: SettlementsPasswordChange,
      nzViewContainerRef: this.viewContainerRef,
      nzData: serviceProviderCode,
      nzFooter: null,
    });
  }
}
